import { gql } from '@apollo/client';

export const DELETE_LEARNING_OBJECT_MUTATION = gql`
    mutation deleteLearningObject($objectID: UUID!) {
        result: deleteLearningObject(objectID: $objectID) {
            affectedRows
        }
    }
`;
